import { fetchSandboxDemoRoster } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';

import { createLotusRequestConfig } from '@/shared/api/lotus';

import type { DemoRoster } from './demoRoster.js';

export async function fetchDemoRoster(signal?: AbortSignal): Promise<DemoRoster> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchSandboxDemoRoster(config);
  return lotusHealthZod.fetchSandboxDemoRosterResponse.parse(response.data).roster;
}
